import React, {useMemo} from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Hidden from '@mui/material/Hidden';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Carousel from '../../Carousel';
import ExistencesCard from './ExistencesCard';

import { existences } from '../../proptypes/existences';
import { plantedSpecies } from '../../../utils/plantedSpecies';
import { useTranslation } from 'react-i18next';

const MenuExistences = ({species}) => {

  const {t} = useTranslation();

  const hasPlantedSpecies = useMemo(() => plantedSpecies(species).length > 0, [plantedSpecies]);

  return <>
    <Hidden lgUp>{/*MOBILE*/}
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start'}}>
        { hasPlantedSpecies ?
          <Carousel>
            {
              plantedSpecies(species).map(
                specie => <Box key={specie.id} sx={{display: 'inline-block'}}>
                  <Paper elevation={0} sx={{width: 200, m: 0.5, p: 0.5}}>
                    <ExistencesCard id={specie.id} label={specie.label} existences={specie.existences} age={specie.age}/>
                  </Paper>
                </Box>
              )
            }
          </Carousel>
          : <Typography sx={{color: 'error.main', textAlign: 'start', mt: 1}}>{t('No hay especies plantadas')}</Typography>
        }
      </Box>

    </Hidden>
    <Hidden lgDown>{/*DESKTOP*/}
      <Box sx={{display: 'flex', flexWrap: 'wrap', maxHeight: 250, overflow: 'auto', mb: 1.5}}>
        {
          hasPlantedSpecies ?
            plantedSpecies(species).map(
              specie => <ExistencesCard key={specie.id} id={specie.id} label={specie.label} existences={specie.existences} age={specie.age}/>
            ) : <Typography sx={{color: 'error.main', textAlign: 'end', mt: 1}}>{t('No hay especies plantadas')}</Typography>
        }
      </Box>
    </Hidden>
  </>;
};

MenuExistences.propTypes = {
  species: PropTypes.arrayOf(existences).isRequired
};

export default MenuExistences;